
import Vue from 'vue'
import fileBaseUrl from "@/plugins/urlBase";
import { submitStudentOrder, getOrderDetail, teacherReviewStudent, getOrderAmount, updateStudentOrder, submitPayment, getConferenceDetail, updateTeacherOrderC } from "@/utils/api";

export default Vue.extend({
  name: 'submission-page',
  data() {
    return {
      currentStep: 1,
      conferenceId: '',
      submitting: false,
      isReadOnly: false,
      mode: 1 as any,
      orderId: '' as any,
      status: '' as any,
      handleType: '' as any,
      reviewDialogVisible: false,
      canSubmit: false,
      originalSourceUrl: '',
      originalPaperUrl: '',
      isRegistrationSubmitted: false,
      paymentDialogVisible: false,
      paymentMethod: 'Alipay',
      receiptFileList: [] as any[],
      registrationInfo: {
        title: '',
        code: '',
        totalPages: 0,
        name: '',
        orderAmount: 0,
        contactInformationName: '',
        contactInformationEmail: '',
        contactInformationPhone: '',
        copyrightAgreement: false,
        aiGuidelines: false
      },
      registrationRules: {
        contactInformationName: [{ required: true, message: 'Please input contactInformationName', trigger: 'blur' }],
        contactInformationEmail: [
          { required: true, message: 'Please input contactInformationEmail', trigger: 'blur' },
          { type: 'email', message: 'Invalid email', trigger: ['blur', 'change'] }
        ],
        contactInformationPhone: [{ required: true, message: 'Please input contactInformationPhone', trigger: 'blur' }]
      },
      reviewForm: {
        code: '',
        totalPages: 0,
        basePages: 0,
        basePublicationFee: 0,
        discountAmount: 0,
        orderAmount: 0
      },
      reviewRules: {
        code: [{ required: true, message: '请输入Code', trigger: 'blur' }],
        totalPages: [{ required: true, message: '请输入Total Pages', trigger: 'blur' }],
        basePages: [{ required: true, message: '请输入Base Pages', trigger: 'blur' }],
        basePublicationFee: [{ required: true, message: '请输入Base Publication Fee', trigger: 'blur' }],
        discountAmount: [{ required: true, message: '请输入Discount Amount', trigger: 'blur' }],
        orderAmount: [{ required: true, message: '请输入Order Amount', trigger: 'blur' }]
      },
      form: {
        conferenceId: '',
        title: '',
        keywords: '',
        abstract: '',
        contactAuthorCorresponding: true,
        contactAuthorName: '',
        contactAuthorEmail: '',
        contactAuthorOrganization: '',
        coAuthors: [
          {
            contactAuthorCorresponding: false,
            contactAuthorName: '',
            contactAuthorEmail: '',
            contactAuthorOrganization: ''
          }
        ],
        sourceUrl: '',
        paperUrl: '',
      },
      rules: {
        title: [{ required: true, message: 'Please input Title', trigger: 'blur' }],
        keywords: [{ required: true, message: 'Please input Keywords', trigger: 'blur' }],
        contactAuthorName: [{ required: true, message: 'Please input Author Name', trigger: 'blur' }],
        contactAuthorEmail: [
          { required: true, message: 'Please input Author Email', trigger: 'blur' },
          { type: 'email', message: 'Invalid email', trigger: ['blur', 'change'] }
        ],
        contactAuthorOrganization: [{ required: true, message: 'Please input Organization', trigger: 'blur' }],
        sourceUrl: [{ required: true, message: 'Please upload .docx source', trigger: 'change' }],
        paperUrl: [{ required: true, message: 'Please upload .pdf paper', trigger: 'change' }]
      },
      fileBaseUrl: fileBaseUrl as any,
      sourceFileList: [] as any[],
      paperFileList: [] as any[],
      RegistrationTitle: "Registration",
      from: '',
      // 弹框控制变量
      copyrightDialogVisible: false,
      aiGuidelinesDialogVisible: false,
      acceptanceLetterUrl: '',
      type: '',
      title: "",
      subTitle: "",
    }
  },
  computed: {
    canEditFiles() {
      // 如果是编辑模式，总是允许编辑文件
      if ((this as any).type === 'edit') {
        return true;
      }
      return ((this as any).mode === '3' && (this as any).status === 'student') || ((this as any).currentStep === 1 && (this as any).type !== 'view')
    },
    canConfirmPayment() {
      return (this as any).receiptFileList.length > 0
    },
    isFieldDisabled() {
      // 如果是查看模式，总是禁用
      if ((this as any).type === 'view') {
        return true;
      }
      // 如果是编辑模式 且mode时6不禁用
      if ((this as any).type === 'edit' && (this as any).mode === '6') {
        return false;
      }


      // 其他情况根据业务逻辑禁用
      return (this as any).isRegistrationSubmitted || (this as any).mode === '5' || (this as any).mode === '6';
    }
  },
  mounted() {

    // 1: 等待老师审核并录入订单金额等数据   ——> submission
    // 2：老师审核并录入数据，等待学生修改数据 ——> Review
    // 3：学生修改数据(也可以不改，要点提交按钮)  ——>Notification
    // 4：学生上传支付截图+录入数据  -——> Registration，
    // 5：老师审核通过(注册) ————> Registration(Under Review) 
    // 6: 生成录用函  ————> Registration(Completed) 
    this.conferenceId = (this.$route.query.conferenceId as any) || ''
    // 通过会议id来获取会议详情进而展示详情
    this.getConferenceDetail(this.conferenceId)
    this.form.conferenceId = this.conferenceId
    // this.mode 将通过订单详情获取，不再从路由获取
    this.orderId = (this.$route.query.orderId as any) || ''
    this.status = (this.$route.query.status as any) || ''
    this.from = (this.$route.query.from as any) || ''
    this.type = (this.$route.query.type as any) || ''

    if (this.orderId) {
      // 直接调用 bootstrap，不再传递 step 参数
      this.bootstrap()
    } else {
      // 如果没有 orderId，设置默认值
      this.mode = 1
      this.currentStep = 1
    }
  },
  watch: {
    'certificateData.abbreviation': {
      handler(newVal) {
        this.resizeText()
      },
      immediate: true
    }
  },
  methods: {
    // 获取会议详情用于展示标题和副标题
    async getConferenceDetail(id: any) {
      try {
        const res: any = await getConferenceDetail(id);
        this.title = res.name
        this.subTitle = res.abbreviation
      } catch (e) {
        this.$message.error('获取会议信息失败');
      }
    },
    // 下载录用函
    async downloadAcceptanceLetter() {
      if (!this.acceptanceLetterUrl) {
        this.$message.warning('录用函尚未生成，请稍后再试');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在准备下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        // 使用fetch API获取文件
        const response = await fetch(this.acceptanceLetterUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        // 创建Blob URL
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;

        // 强制下载设置
        link.download = this.getFileNameFromUrl(this.acceptanceLetterUrl) || 'Acceptance_Letter.pdf';
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 释放Blob URL
        window.URL.revokeObjectURL(blobUrl);

        loading.close();
        this.$message.success('录用函下载完成');
      } catch (error) {
        loading.close();
        console.error('下载失败:', error);

        // 如果Blob方式失败，尝试直接下载
        this.fallbackDownload();
      }
    },
    // 备用下载方法
    fallbackDownload() {
      try {
        const link = document.createElement('a');
        link.href = this.acceptanceLetterUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        // 添加右键"另存为"提示
        this.$message.info('请在打开的PDF页面中右键选择"另存为"');

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.$message.error('下载失败，请联系管理员');
      }
    },

    // 辅助方法：从URL中提取文件名
    getFileNameFromUrl(url: string): string {
      try {
        // 处理直接的文件URL
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);

        // 解码URL编码的文件名
        return decodeURIComponent(fileName);
      } catch (error) {
        // 如果URL解析失败，尝试从路径中提取
        const lastSlashIndex = url.lastIndexOf('/');
        if (lastSlashIndex !== -1) {
          return url.substring(lastSlashIndex + 1);
        }
        return '';
      }
    },
    resizeText() {
      this.$nextTick(() => {
        const div: any = document.querySelector('.div-container');
        const p = div.querySelector('p');
        let fontSize = 96;  // 初始字体大小
        p.style.fontSize = fontSize + 'pt';

        while (p.scrollHeight > div.clientHeight || p.scrollWidth > div.clientWidth) {
          fontSize -= 1;  // 字体逐步缩小
          p.style.fontSize = fontSize + 'pt';
          /*当字体小于12的时候 跳出循环*/
          if (fontSize < 12) {
            break
          }
        }
      })
    },
    // 新增方法：打开版权协议弹框
    openCopyrightDialog(event: Event) {
      event.preventDefault(); // 阻止默认的标签点击行为
      if (!this.isRegistrationSubmitted && this.mode !== '5' && this.mode !== '6') {
        this.copyrightDialogVisible = true;
      }
    },

    // 新增方法：打开AI指南弹框
    openAIGuidelinesDialog(event: Event) {
      event.preventDefault(); // 阻止默认的标签点击行为
      if (!this.isRegistrationSubmitted && this.mode !== '5' && this.mode !== '6') {
        this.aiGuidelinesDialogVisible = true;
      }
    },

    // 新增方法：确认版权协议
    confirmCopyrightAgreement() {
      this.registrationInfo.copyrightAgreement = true;
      this.copyrightDialogVisible = false;
    },

    // 新增方法：确认AI指南
    confirmAIGuidelines() {
      this.registrationInfo.aiGuidelines = true;
      this.aiGuidelinesDialogVisible = false;
    },
    getCardTitle() {
      switch (this.currentStep) {
        case 1: return 'Submit Paper'
        case 2: return 'Review'
        case 3: return 'Notification'
        case 4: return 'Registration'
        default: return 'Submit Paper'
      }
    },
    getStepTitle() {
      switch (Number(this.mode)) {
        case 4: return 'Registration'
        case 5: return 'Registration(Under Review)'
        case 6: return 'Registration(Completed)'
        default: return 'Registration'
      }
    },
    async bootstrap() {
      try {
        const detail: any = await getOrderDetail(this.orderId)

        // 根据路由参数决定使用哪个 mode 值
        const isViewOrEdit = this.type === 'view' || this.type === 'edit'
        if (isViewOrEdit) {
          this.mode = detail.progress || 1
        } else {
          this.mode = detail.progress + 1 === 7 ? detail.progress : detail.progress + 1
        }

        // 确保 mode 是字符串类型，与代码中的比较保持一致
        this.mode = String(this.mode)

        // 将接口字段映射到表单（根据图示字段示例）
        this.form.title = detail.title || ''
        this.form.keywords = detail.keywords || ''
        this.form.abstract = detail.abstract || ''
        this.form.contactAuthorName = detail.contactAuthorName || ''
        this.form.contactAuthorEmail = detail.contactAuthorEmail || ''
        this.form.contactAuthorOrganization = detail.contactAuthorOrganization || ''
        this.form.sourceUrl = detail.sourceUrl || ''
        this.originalSourceUrl = detail.sourceUrl || ''
        this.sourceFileList = this.form.sourceUrl ? [{ name: this.form.sourceUrl, url: this.form.sourceUrl }] : []
        this.form.paperUrl = detail.paperUrl || ''
        this.originalPaperUrl = detail.paperUrl || ''
        this.paperFileList = this.form.paperUrl ? [{ name: this.form.paperUrl, url: this.form.paperUrl }] : []

        // 填充注册信息
        this.registrationInfo = {
          title: detail.title || '',
          code: detail.code || '',
          totalPages: detail.totalPages || 0,
          name: (this.from === 'b' ? detail.authors : detail.contactAuthorName) || '',
          orderAmount: detail.orderAmount || 0,
          contactInformationName: detail.contactInformationName || '',
          contactInformationEmail: detail.contactInformationEmail || '',
          contactInformationPhone: detail.contactInformationPhone || '',
          copyrightAgreement: (this.mode === '5' || this.mode === '6') ? true : (this.type === 'edit' && detail.progress === 4) ? true : false,
          aiGuidelines: (this.mode === '5' || this.mode === '6') ? true : (this.type === 'edit' && detail.progress === 4) ? true : false
        }

        // 若后端返回 coAuthors，则覆盖
        if (Array.isArray(detail.coAuthors) && detail.coAuthors.length) {
          this.form.coAuthors = detail.coAuthors
        }
        if (detail.coAuthors && detail.coAuthors.length === 0) {
          this.form.coAuthors = []
        }

        // 如果存在acceptanceLetterUrl的话就保留为下载做准备
        this.acceptanceLetterUrl = detail.acceptanceLetterUrl || ''

        // 根据 mode 确定当前步骤
        let step
        if (this.mode === '4' || this.mode === '5' || this.mode === '6') {
          step = 4
        } else {
          step = Number(this.mode)
        }

        this.currentStep = step
        // 初始化只读状态基于规则
        this.updateReadOnlyForCurrentStep()

      } catch (e) {
        this.$message.error('加载订单详情失败')
      }
    },
    // 新增：点击步骤切换，仅允许查看/编辑到允许的最大步骤
    onStepClick(step: number) {
      // b端跳转过来的话不允许随便编辑
      if (this.from === 'b') return
      // 如果身份是学生的话不允许跳转
      if (this.status === 'student') return
      const maxView = this.getAllowedMaxViewStep()
      if (step > maxView) return
      this.currentStep = step
      this.updateReadOnlyForCurrentStep()
    },
    // 新增：计算允许查看的最大步骤（view/edit 与 student 流程一致）
    getAllowedMaxViewStep(): number {
      const modeNum = Number((this as any).mode)
      return modeNum >= 4 ? 4 : modeNum
    },
    // 新增：更新当前步骤的只读状态（根据 type 与 mode）
    updateReadOnlyForCurrentStep() {
      const modeStr = (this as any).mode
      const modeNum = Number(modeStr)
      const isView = (this as any).type === 'view'
      const isEdit = (this as any).type === 'edit'

      if (isView) {
        (this as any).isReadOnly = true
        return
      }

      if (!isEdit) {
        // 非编辑、非查看（学生端正常流程），保持原有规则：仅在步骤1可以编辑表单
        // 这里用 currentStep === 1 控制
        (this as any).isReadOnly = (this as any).currentStep !== 1
        return
      }

      // 编辑模式：可编辑当前 mode 及以前的步骤
      // mode<=3: 可编辑 1..mode
      // mode=4: 可编辑 1..4
      // mode=5: 不允许编辑（保持只读）
      // mode=6: 可编辑 1..4
      const editableMax = modeNum <= 3 ? modeNum : (modeNum === 5 ? 0 : 4);
      (this as any).isReadOnly = (this as any).currentStep > editableMax
    },
    async submitRegistration() {
      // 验证表单
      const valid = await new Promise<boolean>((resolve) => {
        (this.$refs.registrationForm as any).validate((ok: boolean) => resolve(ok))
      })
      if (!valid) return

      // 验证协议是否都选中
      if (!this.registrationInfo.copyrightAgreement || !this.registrationInfo.aiGuidelines) {
        this.$message.warning('请同意所有协议条款')
        return
      }

      // 打开支付确认弹框
      this.paymentDialogVisible = true
    },
    async confirmPayment() {
      if (!this.canConfirmPayment) {
        this.$message.warning('请上传支付凭证')
        return
      }

      try {
        const payload = {
          paymentUrl: this.receiptFileList[0].url,
          contactInformationName: this.registrationInfo.contactInformationName,
          contactInformationEmail: this.registrationInfo.contactInformationEmail,
          contactInformationPhone: this.registrationInfo.contactInformationPhone
        }
        await submitPayment(this.orderId, payload)
        this.$message.success('支付提交成功')
        this.paymentDialogVisible = false

        // 设置为已提交状态，所有内容不可编辑
        this.isRegistrationSubmitted = true
        this.isReadOnly = true
        this.mode = '5'
      } catch (e) {
        this.$message.error('支付提交失败')
      }
    },
    beforeUploadReceipt(file: File) {
      const isImage = /\.(jpg|jpeg|png)$/i.test(file.name)
      if (!isImage) {
        this.$message.error('仅支持 .jpg .png 文件')
        return false
      }
      return true
    },
    handleReceiptSuccess(res: any) {
      if (res.error && res.error.returnMessage === 'success') {
        this.receiptFileList = [{ name: res.data.name, url: res.data.ossUrl }]
      } else {
        this.$message.error('上传失败')
        this.receiptFileList = []
      }
    },
    handleReceiptRemove() {
      this.receiptFileList = []
    },
    async submitNotification() {
      if (this.submitting) return
      this.submitting = true

      try {
        const payload: any = {}

        payload.sourceUrl = this.form.sourceUrl
        payload.paperUrl = this.form.paperUrl
        await updateStudentOrder(this.orderId, payload)

        this.$message.success('提交成功')
        // 跳转到第四个板块
        this.currentStep = 4
        this.mode = '4'
        this.isReadOnly = true
      } catch (e) {
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    openReviewDialog() {
      this.reviewDialogVisible = true
      // 初始化审核表单数据
      this.reviewForm = {
        code: '',
        totalPages: 0,
        basePages: 0,
        basePublicationFee: 0,
        discountAmount: 0,
        orderAmount: 0
      }
      this.canSubmit = false
    },
    async calculateOrderAmount() {
      // 检查所有必需字段是否已填写
      if (!this.reviewForm.totalPages || !this.reviewForm.basePages ||
        !this.reviewForm.basePublicationFee || this.reviewForm.discountAmount === null) {
        this.canSubmit = false
        return
      }

      try {
        const params = {
          totalPages: this.reviewForm.totalPages,
          basePages: this.reviewForm.basePages,
          basePublicationFee: this.reviewForm.basePublicationFee,
          discountAmount: this.reviewForm.discountAmount
        }

        const res: any = await getOrderAmount(params)

        if (res.orderAmount) {
          this.reviewForm.orderAmount = res.orderAmount
          this.canSubmit = true
        } else {
          this.$message.error('计算订单金额失败')
          this.canSubmit = false
        }
      } catch (e) {
        this.$message.error('计算订单金额失败')
        this.canSubmit = false
      }
    },
    async submitReview() {
      if (!this.canSubmit) {
        this.$message.warning('请先计算订单金额')
        return
      }

      const valid = await new Promise<boolean>((resolve) => {
        (this.$refs.reviewForm as any).validate((ok: boolean) => resolve(ok))
      })
      if (!valid) return

      try {
        await teacherReviewStudent(this.orderId, this.reviewForm)
        this.$message.success('审核成功')
        this.reviewDialogVisible = false
        // 关闭当前页面并刷新父页面
        if (window.opener) {
          window.opener.location.reload()
          window.close()
        }
      } catch (e) {
        this.$message.error('审核失败')
      }
    },
    addCoAuthor() {
      this.form.coAuthors.push({
        contactAuthorCorresponding: false,
        contactAuthorName: '',
        contactAuthorEmail: '',
        contactAuthorOrganization: ''
      })
    },
    removeCoAuthor(index: number) {
      this.form.coAuthors.splice(index, 1)
    },
    beforeUploadDocx(file: File) {
      const ok = /\.docx$/i.test(file.name)
      if (!ok) this.$message.error('仅支持 .docx 文件')
      return ok
    },
    beforeUploadPdf(file: File) {
      const ok = /\.pdf$/i.test(file.name)
      if (!ok) this.$message.error('仅支持 .pdf 文件')
      return ok
    },
    handleSourceSuccess(res: any) {
      if (res.error && res.error.returnMessage === 'success') {
        this.form.sourceUrl = res.data.ossUrl
        this.sourceFileList = [{ name: res.data.name, url: res.data.ossUrl }]
        this.$nextTick(() => (this.$refs.submitForm as any).validateField('sourceUrl'))
      } else {
        this.$message.error('上传失败')
        this.sourceFileList = []
      }
    },
    handleSourceRemove() {
      this.form.sourceUrl = ''
      this.sourceFileList = []
      this.$nextTick(() => (this.$refs.submitForm as any).validateField('sourceUrl'))
    },
    handlePaperSuccess(res: any) {
      if (res.error && res.error.returnMessage === 'success') {
        this.form.paperUrl = res.data.ossUrl
        this.paperFileList = [{ name: res.data.name, url: res.data.ossUrl }]
        this.$nextTick(() => (this.$refs.submitForm as any).validateField('paperUrl'))
      } else {
        this.$message.error('上传失败')
        this.paperFileList = []
      }
    },
    handlePaperRemove() {
      this.form.paperUrl = ''
      this.paperFileList = []
      this.$nextTick(() => (this.$refs.submitForm as any).validateField('paperUrl'))
    },
    handleExceed() {
      this.$message({ message: '只能上传一个文件，请先删除已上传的文件', type: 'warning' })
    },
    async onSubmit() {
      if (this.submitting) return
      const valid = await new Promise<boolean>((resolve) => {
        (this.$refs.submitForm as any).validate((ok: boolean) => resolve(ok))
      })
      if (!valid) return
      this.submitting = true
      try {
        const payload = {
          conferenceId: this.form.conferenceId,
          title: this.form.title,
          keywords: this.form.keywords,
          abstract: this.form.abstract,
          contactAuthorCorresponding: this.form.contactAuthorCorresponding,
          contactAuthorName: this.form.contactAuthorName,
          contactAuthorEmail: this.form.contactAuthorEmail,
          contactAuthorOrganization: this.form.contactAuthorOrganization,
          coAuthors: this.form.coAuthors,
          sourceUrl: this.form.sourceUrl,
          paperUrl: this.form.paperUrl
        }
        const response: any = await submitStudentOrder(payload)
        this.$message.success('提交成功')

        // 如果是从会议链接跳转过来的，更新路由并刷新页面
        let origin = location.hostname
        let baseUrl: any = "";
        if (process.env.NODE_ENV === 'development') {
          baseUrl = window.location.origin
        } else {
          baseUrl = origin.includes('-testserver')
            ? window.location.origin
            : 'http://submission.cambridgeinnovationcenter.org'
        }
        if (this.from === 'conference' && response && response.id) {
          const newUrl = `${baseUrl}/submission?conferenceId=${encodeURIComponent(this.conferenceId)}&orderId=${response.id}&status=student&from=c`
          window.location.href = newUrl
          return
        }

        // 进入步骤二：Review；步骤一与步骤二高亮
        this.currentStep = 2
        // 禁用所有编辑：通过只读状态禁用表单与上传
        this.disableAll()
      } catch (e) {
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    // c端修改订单
    async EditOrder() {
      // 仅当从consumerManagement以编辑模式进入时生效
      if (this.type !== 'edit') return

      try {
        const step = Number(this.mode)
        // 步骤1：Submission 可编辑论文基本信息与文件
        if (step === 1 || step === 2 || step === 3) {
          const valid = await new Promise<boolean>((resolve) => {
            (this.$refs.submitForm as any).validate((ok: boolean) => resolve(ok))
          })
          if (!valid) return

          const payload: any = {
            title: this.form.title,
            keywords: this.form.keywords,
            abstract: this.form.abstract,
            contactAuthorCorresponding: this.form.contactAuthorCorresponding,
            contactAuthorName: this.form.contactAuthorName,
            contactAuthorEmail: this.form.contactAuthorEmail,
            contactAuthorOrganization: this.form.contactAuthorOrganization,
            coAuthors: this.form.coAuthors,
            sourceUrl: this.form.sourceUrl,
            paperUrl: this.form.paperUrl
          }
          await updateTeacherOrderC(this.orderId, payload)
          this.$message.success('已保存修改')
          // 关闭当前页面并刷新父页面
          if (window.opener) {
            window.opener.location.reload()
            window.close()
          }
          return
        }

        // 步骤4及以后：注册信息仅学生端在支付前可改，这里不处理
        if (step === 4 || step === 5 || step === 6) {
          // 验证协议是否都选中
          if (!this.registrationInfo.copyrightAgreement || !this.registrationInfo.aiGuidelines) {
            this.$message.warning('请同意所有协议条款')
            return
          }
          const payload: any = {
            title: this.form.title,
            keywords: this.form.keywords,
            abstract: this.form.abstract,
            contactAuthorCorresponding: this.form.contactAuthorCorresponding,
            contactAuthorName: this.form.contactAuthorName,
            contactAuthorEmail: this.form.contactAuthorEmail,
            contactAuthorOrganization: this.form.contactAuthorOrganization,
            coAuthors: this.form.coAuthors,
            sourceUrl: this.form.sourceUrl,
            paperUrl: this.form.paperUrl,
            contactInformationName: this.registrationInfo.contactInformationName,
            contactInformationEmail: this.registrationInfo.contactInformationEmail,
            contactInformationPhone: this.registrationInfo.contactInformationPhone
          }
          await updateTeacherOrderC(this.orderId, payload)
          this.$message.success('已保存修改')
          // 关闭当前页面并刷新父页面
          if (window.opener) {
            window.opener.location.reload()
            window.close()
          }
          return
        }
      } catch (e) {
        this.$message.error('保存失败，请稍后重试')
      }
    },
    disableAll() {
      // 禁用上传
      // 通过清空 action 或设置文件列表禁用交互也可，这里通过标志位控制界面禁用
      this.isReadOnly = true
    }
  }
})
